import React, { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { useCrm } from "../../pages/crm/CrmApp";
import { money, fmtDate } from "../../lib/crmApi";

export const Sales = () => {
  const { api, isOwner, go } = useCrm();
  const [list, setList] = useState(null);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const load = () => api("/sales").then(setList);
  useEffect(() => {
    load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const shown = (list || []).filter((s) => !month || s.date.slice(0, 7) === month);
  const total = shown.reduce((a, s) => a + s.amount, 0);
  const comm = shown.reduce((a, s) => a + s.commission, 0);
  const pend = shown.filter((s) => !s.commission_paid).reduce((a, s) => a + s.commission, 0);
  const togglePaid = async (s) => {
    await api(`/sales/${s.id}/commission?paid=${!s.commission_paid}`, { method: "PUT" });
    load();
  };
  const del = async (s) => {
    if (!window.confirm("¿Eliminar esta venta?")) return;
    await api(`/sales/${s.id}`, { method: "DELETE" });
    load();
  };
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-2xl font-bold text-slate-900">{isOwner ? "Ventas y comisiones" : "Mis ventas y comisiones"}</h1>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm" data-testid="crm-sales-month" />
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-3"><p className="text-[11px] text-slate-500">Vendido</p><p className="font-bold text-slate-900" data-testid="crm-sales-total">{money(total)}</p></div>
        <div className="rounded-2xl border border-slate-200 bg-white p-3"><p className="text-[11px] text-slate-500">Comisiones</p><p className="font-bold text-slate-900" data-testid="crm-sales-commission">{money(comm)}</p></div>
        <div className="rounded-2xl border border-slate-200 bg-white p-3"><p className="text-[11px] text-slate-500">Por pagar</p><p className="font-bold text-amber-600" data-testid="crm-sales-pending">{money(pend)}</p></div>
      </div>
      <p className="text-xs text-slate-500">Para registrar una venta abre al cliente en <button className="underline" onClick={() => go("contacts")}>Clientes</button> y toca "Registrar venta".</p>
      {list && !shown.length && <p className="py-10 text-center text-sm text-slate-400" data-testid="crm-sales-empty">Sin ventas en este mes.</p>}
      <div className="space-y-2">
        {shown.map((s) => (
          <div key={s.id} className="rounded-2xl border border-slate-200 bg-white p-3.5" data-testid={`crm-sale-${s.id}`}>
            <div className="flex items-start justify-between gap-2">
              <button className="min-w-0 text-left" onClick={() => go("contacts", s.contact_id)}>
                <p className="truncate text-sm font-semibold text-slate-900">{s.contact_name}</p>
                <p className="truncate text-xs text-slate-500">{s.description || "Venta"} · {fmtDate(s.date)}{isOwner && ` · ${s.seller_name}`}</p>
              </button>
              <p className="shrink-0 font-bold text-slate-900">{money(s.amount)}</p>
            </div>
            <div className="mt-2 flex items-center justify-between gap-2 text-xs">
              <span className="text-slate-500">Comisión {s.commission_rule}: <b className="text-slate-800">{money(s.commission)}</b></span>
              <div className="flex items-center gap-2">
                {isOwner && s.commission > 0 ? (
                  <button onClick={() => togglePaid(s)} className={`rounded-full px-2.5 py-1 font-semibold ${s.commission_paid ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`} data-testid={`crm-sale-paid-${s.id}`}>{s.commission_paid ? "Pagada" : "Marcar pagada"}</button>
                ) : s.commission > 0 ? (
                  <span className={`rounded-full px-2.5 py-1 font-semibold ${s.commission_paid ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{s.commission_paid ? "Pagada" : "Pendiente"}</span>
                ) : null}
                {isOwner && <button onClick={() => del(s)} className="text-slate-400 hover:text-red-500" data-testid={`crm-sale-delete-${s.id}`}><Trash2 className="h-3.5 w-3.5" /></button>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
